import api from "../api"; // Importa o axios configurado

/**
 * Lista chamados do banco de dados com filtros opcionais
 * @param {Object} filtros - Filtros de pesquisa
 * @param {string} [filtros.dataInicial] - Data inicial do filtro (YYYY-MM-DD)
 * @param {string} [filtros.dataFinal] - Data final do filtro (YYYY-MM-DD)
 * @param {string} [filtros.cliente] - Nome do cliente
 * @param {string} [filtros.funcionario] - Nome do funcionário
 * @returns {Promise<Object>} - Dados retornados do backend
 */
export async function listarChamados(filtros = {}) {
  try {
    const response = await api.post("/relatorio-chamado/listar.php", filtros, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data; // Retorna o JSON do backend
  } catch (error) {
    console.error("Erro ao listar chamados:", error);

    if (error.response && error.response.data) {
      throw error.response.data;
    }

    throw new Error("Erro ao conectar com o servidor.");
  }
}
